<script setup>
import AppLoader from "@/components/Ui/AppLoader.vue";
import { defineProps } from "vue";

defineProps({
  isLoading: {
    type: Boolean,
    required: true,
  },
});
</script>

<template v-if="isLoading">
  <div class="page-loader">
    <AppLoader />
  </div>
</template>

<style scoped lang="scss">
.page-loader {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  > svg {
    width: 120px;
  }
}
</style>
